jQuery(document).ready(function($){

    if ( $('.nf-testimonial-slider-block') ) {
        var slider = $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper');
        var nextbut = slider.parent().find('.next-btn');
        $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: nextbut,
            dots: false,
            fade: true,
        });

        var $progressBar = $('.progress');
        var $progressBarLabel = $( '.slider__label' );
        var $curSlideLabel = $('.slider__label__current');
        var $totalSlideLabel = $('.slider__label__total');

        slider.on('reInit', function(slick) {
            $totalSlideLabel.text( slick.slideCount );
        });
        
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
          $totalSlideLabel.text( slick.slideCount );
          var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
          
          $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );
          
          $progressBarLabel.text( calc + '% completed' );
          $curSlideLabel.text( nextSlide + 1);
         
        }); 
    }
});
    
    
        